export const invalidStyles = {
  control: (styles: any) => ({
    ...styles,
    backgroundColor: "white",
    border: "1px solid #e83a14",
  }),
};
